import type { AxiosResponse } from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';
import type { ActionType } from 'typesafe-actions';

import type { LoanSummary } from '@evenfinancial/demand-reporting-client';

import { client } from '@portal/api-client/src/client';

import { getPersonalLoanSummaryByDemandSubAccountUuidAction } from './actions';

export function* getPersonalLoanSummaryByDemandSubAccountUuid(
  action: ActionType<
    typeof getPersonalLoanSummaryByDemandSubAccountUuidAction.request
  >
) {
  try {
    const { demandSubAccountUuid } = action.payload;

    const { data: loanSummary }: AxiosResponse<LoanSummary> = yield call(
      [client, 'get'],
      '/demandReporting/personalLoanSummaries',
      { params: action.payload }
    );

    yield put(
      getPersonalLoanSummaryByDemandSubAccountUuidAction.success({
        demandSubAccountUuid,
        loanSummary,
      })
    );
  } catch (err: any) {
    yield put(getPersonalLoanSummaryByDemandSubAccountUuidAction.failure(err));
  }
}

export function* demandReportingSaga() {
  yield takeEvery(
    getType(getPersonalLoanSummaryByDemandSubAccountUuidAction.request),
    getPersonalLoanSummaryByDemandSubAccountUuid
  );
}
